import React from 'react';

const Redirector = (props) => {
    window.location.replace(props.newURL);

    return React.Fragment;
};

export default Redirector;
